import AiAgentMessageInput, {
  AiAgentMessageInputProps,
} from '../AiAgentMessageInput';
import AiAgentMessageLog, {
  AiAgentMessageLogProps,
} from '../AiAgentMessageLog';

export type AiAgentConversationProps = AiAgentMessageInputProps &
  AiAgentMessageLogProps & {};

const AiAgentConversation: React.FC<AiAgentConversationProps> = props => {
  return (
    <div
      data-component="AiAgentConversation"
      className="relative flex flex-1 flex-col py-4"
    >
      <AiAgentMessageLog {...props} />
      <AiAgentMessageInput {...props} />
    </div>
  );
};

export default AiAgentConversation;
